module.exports = __webpack_public_path__ + "img/public/SiteIcons/makeIcon.svg?9e0751ed";